import {React,useEffect,useReducer,useContext} from 'react'
import {productdetails} from '../component/Fetcher'
import { useParams } from 'react-router-dom'
import {conitem } from '../context/Contextitem'
import styled from 'styled-components'
import { Footer } from '../component/Footer1'
import Hotdeal from '../component/Hotdeal'
import Header from '../component/Header'
import { Bestselling } from '../component/Bestselling'
import Nav from '../component/Nav';



const initaistate = {
  data : {},
  loading : true,
  error : ' '
}



const reducer = (state,action)=>{
  switch(action.type){
    case 'sucess':
    return{
      loading : false,
      data : action.payload,
      error : ''
    }
    case 'error' :
      return{
        loading : false,
        data : '',
        error : action.errormessage
      
      }

  }

}
const Productdetail = () => {
  
   const {Productid} = useParams()
   const value = useContext(conitem )
   const {addproduct} = value
   
const[productdata,dispatch]  =  useReducer(reducer,initaistate)

const newvar = productdata.data.imag

console.log(productdata.data.imag)

useEffect(()=>{
  productdetails({Productid, dispatch})
},[Productid])
const markup = ()=>{
  return{
 __html :productdata.data?.description
  }
}

const duplicate =()=>{

 return newvar?.map((data)=>{
  return <div id='duplicate'>
  <img src={`/asset/${data}`}/>
  </div>

})
}

 

  return (
    <>
     <Nav/>
   <ProductDistritionWrapper>


    <div className='product-img-wrapper' >


  
    <ProductDistritionImg src={`/asset/${productdata.data.image}`}/>

    <div id='four-image'>
 {
  
    duplicate()
   }
</div>

    </div>

    <div className='product-feature'>
    <ProductImgWrapperh4>{productdata.data.title}</ProductImgWrapperh4>
    <h6 style={{fontSize:'15px',padding:'0',margin:'0',fontWeight:'normal'}}>
      &pound;{productdata.data.price}
        </h6>
        <h5 style={{color:'green',margin:'10px 0 0 0'}}> {`Stock level : ${productdata.data.stock}`}</h5>
      <h3 style={{margin:'10px 0 '}}> description</h3>
      <h6 style={{fontWeight:'normal',margin:'0'}} dangerouslySetInnerHTML={markup()}></h6>
      
      <div className='product-info-finace'>
    

<div className='wrapper'>
       
       <div className='btn-wrapper'>

       
        <ProductInfoFinaceStockBtn onClick={()=>addproduct(productdata.data)}>Add to Basket</ProductInfoFinaceStockBtn>
        </div>
      </div>
      </div>
     

      <div id='free-delivery-wrapper'>
<img src={`./asset/Vector.png`}/>
<div id='free-delivery-wrapper-text'>
  <p style={{margin:'0 0 10px 0'}}>Free Delivery</p> 
  <span style={{margin:'0',fontWeight:'normal'}}>Enter your postal code for Delivery Availability</span>
</div>
      </div>

      <div id='free-delivery-wrapper'>
<img src={`./asset/Icon-return.png`}/>
<div id='free-delivery-wrapper-text'>
  <p style={{margin:'0 0 10px 0'}}>Return Delivery</p> 
  <span style={{margin:'0',fontWeight:'normal'}}>Free 30 Days Delivery Returns. Details</span>
</div>
      </div>
    </div>


  




    {/* <ProductDistritionTitle dangerouslySetInnerHTML={markup()}></ProductDistritionTitle> */}
   
    </ProductDistritionWrapper>
    <Hotdeal/>
   <div id='house-wrapper'>
   <Bestselling/>
   
   </div>
    


  <Footer/>
    </>
  )
}

const ProductDistritionWrapper = styled.div`
background-color: white;
  display: grid;
  grid-template-columns:  1fr 1fr;


  @media (min-width:300px){
    display: block;
    grid-template-columns: none;
    padding:20px 5px;
 
  }

  @media (min-width:600px){
    display: block;
    grid-template-columns: none;
    padding:20px 5px;
 
  }

  @media (min-width:992px){
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding:20px 5px;
    
    
  }


`
const ProductImgWrapperh4 = styled.h4`
font-size: 12px;

`
const ProductDistritionImg = styled.img`
width: 310px;

text-align: center;
background-color:'red',



@media (min-width:768px){
  width: 450px;



}

@media (min-width:992px){
  width: 70%;

text-align: center;

}


`
const ProductDistritionTitle = styled.label`
padding: 10px;
grid-column: 1 /span 2;
font

`

const ProductInfoFinacePrice = styled.div`
margin-top: 20px;
font-size: 1px;


@media (min-width:300px){
  text-align: center;

}
@media (min-width:600px){
  text-align: center;

}

@media (min-width:764px){
  text-align: left;

}


@media (min-width:992px){
  margin-top: 20px;
  font-size: 20px;
  font-weight: bolder;

}

`
const ProductInfoFinaceStock = styled.div`
width: 190px;
background-color: wheat;
font-size: 20px;
padding: 10px;
margin: 20px 0;
font-weight : bold;

@media (min-width:300px){
  margin:20px auto;

}

@media (min-width:768px){
  width: 190px;
background-color: wheat;
font-size: 20px;
padding: 10px;
margin: 20px 0;
font-weight : bold;


}

@media (min-width:992px){
  width: 190px;
  background-color: wheat;
  font-size: 20px;
  padding: 10px;
  margin: 20px 0;
  font-weight : bold;

}

`
const ProductInfoFinaceStockBtn = styled.button`
color: white;
  font-size: 15px;
  padding: 10px 10px;
  font-weight: 700;
  border-radius: 5px;
 
  border: none;
  background-color: red;
  margin: 10px 0;
  display: inline;

  @media (min-width:300px){
    display :block;
    margin : 20px auto;
  
  }
  @media (min-width:992px){
    padding: 10px 10px;
  font-weight: 700;
  border-radius: 5px;
  margin: 0 0;
  border: none;
  background-color: red;
  margin: 10px 0;
  display: inline;
  
  }
`
export default Productdetail